import React, { useState, useEffect } from 'react';
import { Monitor, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { company, navLinks } from '../mock';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Build a target for a hash-based nav link that works from any page
  const hashHref = (hash) => (onHome ? hash : `/${hash}`);

  const renderLink = (link, onClick, className) => {
    if (link.route) {
      return (
        <Link key={link.label} to={link.route} onClick={onClick} className={className}>
          {link.label}
        </Link>
      );
    }
    return (
      <a key={link.label} href={hashHref(link.href)} onClick={onClick} className={className}>
        {link.label}
      </a>
    );
  };

  const deskClass =
    'text-[15px] font-medium text-slate-600 hover:text-blue-600 transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-blue-600 hover:after:w-full after:transition-all';
  const mobileClass = 'block py-2.5 text-slate-700 font-medium hover:text-blue-600';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-[70px]">
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center text-white shadow-sm group-hover:scale-105 transition-transform">
              <Monitor size={20} />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-slate-900 text-lg">{company.name} <span className="text-blue-600">{company.suffix}</span></div>
              <div className="text-[11px] text-slate-500 -mt-0.5">IT Support & Solutions</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => renderLink(link, undefined, deskClass))}
          </nav>

          <div className="hidden lg:block">
            <Button asChild className="bg-slate-900 hover:bg-slate-800 text-white rounded-lg px-5">
              <a href={hashHref('#contact')}>Get Support</a>
            </Button>
          </div>

          <button className="lg:hidden text-slate-800" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-5 py-4 space-y-1 shadow-lg">
          {navLinks.map((link) => renderLink(link, () => setOpen(false), mobileClass))}
          <Button asChild className="w-full mt-2 bg-slate-900 hover:bg-slate-800 text-white">
            <a href={hashHref('#contact')} onClick={() => setOpen(false)}>Get Support</a>
          </Button>
        </div>
      )}
    </header>
  );
};

export default Header;
